import { computed } from "mobx";
import _ from 'lodash';

class HydroMeteoStore {

  rainfallRange = [
    { check: value => +value > 140, color: '#8B0000', label: '>140' },
    { check: value => +value > 120 && +value <= 140, color: '#ff0000', label: '140' },
    { check: value => +value > 100 && +value <= 120, color: '#FFA500', label: '120' },
    { check: value => +value > 80 && +value <= 100, color: '#FFFF00', label: '100' },
    { check: value => +value > 0.6 && +value <= 80, color: '#66FF00', label: '80' },
    { check: value => +value > 0.5 && +value <= 0.6, color: '#B7DDE9', label: '0.6' },
    { check: value => +value > 0 && +value <= 0.5, color: '#808080', label: '0.5' },
    { check: value => +value === 0, color: '#D3D3D3', label: '0' },
  ];
  waterlevelRange = [
    { check: (value, dangerValue) => value < dangerValue - 0.5, color: '#0FF14E', label: 'Normal Level' },
    { check: (value, dangerValue) => value >= dangerValue - 0.5 && value < dangerValue, color: '#F1E80F', label: 'Danger Level' },
    { check: (value, dangerValue) => value >= dangerValue && value < dangerValue + 0.5, color: '#F010DA', label: 'Flood' },
    { check: (value, dangerValue) => value >= dangerValue + 0.5, color: '#F01313', label: 'Severe Flood' },
  ]

  getRainfallRangeColor = value => this.rainfallRange.find(item => !!item.check(value)).color;
  getHydrologyRangeColor = (stage15M, dangerLevel) => {
    if (!stage15M || !dangerLevel || !stage15M.value || !dangerLevel.value) return '#D3D3D3';
    return this.waterlevelRange.find(item => !!item.check(+stage15M.value, +(dangerLevel.value.toString().replace('m', '').trim()))).color;
  }

  constructor(stationStore, mapStore) {
    this.stationStore = stationStore;
    this.mapStore = mapStore;
  }

  @computed get rainfallMarkers() {
    const { mapStore } = this;
    if (!mapStore.stationsJson.length) return [];
    let markers = mapStore.stationsJson.reduce((acc, station) => {
      let rainfall_10m = !!station.parameters && station.parameters.find(item => item.parameter_id === 61);
      let rainfall_1h = !!station.parameters && station.parameters.find(item => item.parameter_id === 62);
      if (!!station.latitude && !!station.longitude && !!rainfall_1h) {
        let color = this.getRainfallRangeColor(rainfall_1h.value);
        let marker = Object.assign({}, {
          id: `rainfall-station_marker-${station.id}`,
          station_id: station.id,
          latitude: station.latitude, longitude: station.longitude,
          position: [station.latitude, station.longitude],
          color: color,
          icon: `<svg id="${'rainfal_map_marker-' + station.id}" viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px; margin-top: -2px;">
              <circle cx="5" cy="5" r="4" stroke="black" stroke-width="0.5px" fill="${color}" />
            </svg>`,
          station,
          rainfall_10m, rainfall_1h
        });
        acc.push(marker);
      }
      return acc;
    }, []);
    return markers;

  }

  @computed get hydrologyMarkers() {
    const { mapStore } = this;
    if (!mapStore.stationsJson.length || !this.stationStore.items.length) return [];
    let markers = mapStore.stationsJson.reduce((acc, station) => {
      let stationItem = this.stationStore.findById(station.id)
      let stage_15M = !!station.parameters && station.parameters.find(item => item.parameter_id === 22);
      let dangerLevel = !!stationItem.meta_data && stationItem.meta_data.find(item => item.name === 'Danger Level');
      if (!!station.latitude && !!station.longitude && !!stage_15M) {
        let color = this.getHydrologyRangeColor(stage_15M, dangerLevel);
        let marker = {
          id: `hydrology-station_marker-${station.id}`,
          station_id: station.id,
          station_name: station.name,
          latitude: station.latitude, longitude: station.longitude,
          position: [station.latitude, station.longitude],
          dangerLevel: dangerLevel ? dangerLevel.value : '',
          color: color,
          icon: `<svg id="${'hydrology_map_marker-' + station.id}" viewBox="0 0 10 10" x="5" width="10" style="margin-left: -1px; margin-top: -2px;">
              <circle cx="5" cy="5" r="4" stroke="black" stroke-width="0.5px" fill="${color}" />
            </svg>`,
          station,
          stage_15M,
        };
        acc.push(marker);
      }
      return acc;
    }, []);
    return markers;
  }


}

export default HydroMeteoStore;


// WEBPACK FOOTER //
// ./src/stores/HydroMeteoStore.js